import { SettingsContext } from '@f_qwep/context/Settings_context';
import React, { useContext, useEffect, useState } from 'react';
import { AccountsContext } from '@f_qwep/context/Accounts_context';
import GeneralJoyride from '../GeneralJoyride';
import { ManualContext } from '@f_qwep/context/Manual_context';
import { IconMaskotQWEP } from '@f_components/icons/IconMascotQwep';

export function WelcomePage() {
    const { setChooseManual } = useContext(ManualContext);

    const [run, setRun] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [steps, setSteps] = useState<any>([
        {
            target: '#root',
            title: 'Добро пожаловать в QWEP!',
            content: (
                <div>
                    {' '}
                    <IconMaskotQWEP />{' '}
                    <p>
                        Приветствуем Вас в самом популярном приложении для поиска запчастей в <b>один клик</b>! <br />{' '}
                        Мы заберем на себя весь рутинный труд, предложим много возможностей сделать вашу работу
                        эффективнее, бизнес прибыльнее и каждый день наполним приятными впечатлениями!
                    </p>
                </div>
            ),
            disableBeacon: true,
            hideFooter: false,
            spotlightClicks: false,
            placement: 'center',
        },
    ]);

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/' || window.location.pathname == '/app-qwep') {
            setRun(true);
            setCurrentStep(0);
        }
    }, []);

    const handleJoyrideCallback = (data: any) => {
        const { action, step, index, status, type } = data;

        if (type === 'step:after' && action === 'next' && !step.hideFooter) {
            setCurrentStep((prevStep) => prevStep + 1);
        } else if (type === 'step:before') {
        } else if (
            type === 'step:after' &&
            (action === 'skip' || action === 'close' || action === 'last' || action === 'skip')
        ) {
            setCurrentStep(0);
            setChooseManual();

            setRun(false);
        }
    };

    return (
        <div>
            <GeneralJoyride steps={steps} run={run} callback={handleJoyrideCallback} stepIndex={currentStep} />
        </div>
    );
}
